module.exports = __webpack_public_path__ + "static/media/17.f644e4bd.jpeg";